import { Injectable } from '@angular/core';

/**
 * LoggerService (Angular 18).
 *
 * Replaces the AngularJS legacy service at:
 *   apps/b2b-ui/common/services/logger/logger.service.js
 *
 * Collects arbitrary log entries in-memory, used by the `application.failed`
 * route to surface accumulated transition errors. Exposed to AngularJS via
 * `downgradeInjectable` under the legacy name `'LoggerService'` (see
 * ng-downgraded-components.ts).
 */
export interface LoggerErrorEnvelope {
  error?: { data?: unknown } | unknown;
}

export type LoggerEntry = LoggerErrorEnvelope | unknown;

export interface LoggerErrorsResult {
  errors: string | unknown[];
  logs: LoggerEntry[];
}

@Injectable({ providedIn: 'root' })
export class LoggerService {
  logs: LoggerEntry[] = [];

  init(): void {}

  log(message: LoggerEntry): void {
    this.logs.push(message);
  }

  get(index: number): LoggerEntry {
    return this.logs[index];
  }

  errors(stringify: boolean, flush: boolean): LoggerErrorsResult | false {
    const extracted: unknown[] = [];

    for (const entry of this.logs) {
      const wrapped = entry as LoggerErrorEnvelope;
      if (wrapped && wrapped.error) {
        const data = (wrapped.error as { data?: unknown })?.data;
        const value = data ? data : wrapped.error;
        extracted.push(stringify ? JSON.stringify(value, null, 2) : value);
      }
    }

    const snapshot = flush ? this.flush() : this.logs;

    if (snapshot.length === 0) {
      return false;
    }

    return {
      errors: stringify ? (extracted as string[]).join('\n') : extracted,
      logs: snapshot,
    };
  }

  flush(): LoggerEntry[] {
    return this.logs.splice(0, this.logs.length);
  }
}
